import { Button } from '@/components/ui/button'
import { AppTooltip } from '@components/AppTooltip'
import type { Component, JSX } from 'solid-js'
import { css } from 'styled-system/css'
import { promptTooltipClass } from '../promptTooltipClass'

// The prototype's exact update/pencil icon (copied verbatim from its inline SVG).
const PencilIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M4 20h4L19 9l-4-4L4 16v4z" />
    <path d="M14 6l4 4" />
  </svg>
)

interface UpdateButtonProps {
  onClick: (e: MouseEvent) => void
  // The card uses the prototype's .upd (14px/8px padding, 12.5px text); the
  // rail row uses its smaller .rfoot .upd variant (12px/7px, 12px text).
  size?: 'card' | 'rail'
}

export const UpdateButton: Component<UpdateButtonProps> = (props) => {
  const isRail = () => props.size === 'rail'

  return (
    <AppTooltip
      delay={900}
      content='Update Setup'
      contentClass={promptTooltipClass}
    >
      <Button
        variant="outline"
        color="fg.default"
        bg="gray.surface.bg"
        gap='6px'
        h='auto'
        px={isRail() ? '12px' : '14px'}
        py={isRail() ? '7px' : '8px'}
        fontSize={isRail() ? '12px' : '12.5px'}
        fontWeight='700'
        borderRadius='8px'
        boxShadow='0 1px 2px rgba(20,22,27,.05)'
        class={css({
          borderColor: 'rgba(20, 22, 27, 0.16)',
          '& svg': {
            width: '13px',
            height: '13px',
          },
          _hover: {
            bg: '#f3f4f2',
          },
        })}
        onClick={(e: MouseEvent) => {
          e.stopPropagation()
          props.onClick(e)
        }}
      >
        <PencilIcon />
        Update
      </Button>
    </AppTooltip>
  )
}
